import React from "react";
import Navbar from "../components/Navbar";
import SecondaryHero from "../components/SecondaryHero";
import OurTechnology from "../components/OurTechnology";
import ServicesSolution from "../components/ServicesSolution";
import { Servicesofweb } from "../components/Data/ServiceData";
import Servicesbuttom from "../components/Servicesbuttom";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async"; // ✅ Added Helmet import

const WebServic = () => {
  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Web Design & Development | VisionBird Technologies</title>
        <meta
          name="description"
          content="Custom web solutions using React, Node.js, and MongoDB. VisionBird Technologies delivers scalable, robust, and high-performance websites and software."
        />
      </Helmet>

      <Navbar />
      <SecondaryHero
        title="WEB DESIGN & "
        highlight="DEVELOPMENT"
        titleLast="?"
        description="(We offer customized web solutions to enhance your business 
        operations with the use of advanced technologies such as 
        JavaScript, React, MongoDB and Node.js. From websites to 
        custom software development, our team of experts will 
        collaborate with you to deliver a seamless and efficient 
        outcome. Let us help boost your business.)"
        image="/assets/Images/Website designer-pana 1.png"
      />

      <OurTechnology />

      <ServicesSolution
        title="OUR"
        highlight=" TECHNOLOGIES"
        description="VisionBird leverages cutting-edge technologies to deliver robust, scalable, and future-oriented custom software solutions to meet the unique needs of its clients."
        servicesData={Servicesofweb}
      />

      <Servicesbuttom
        teamImages={[
          "/assets/Images/hassanteam.jpg",
          "/assets/Images/iqbalhassan.jpeg",
          "/assets/Images/ahsan.jpeg",
        ]}
      />

      <Footer />
    </>
  );
};

export default WebServic;